import { InjectionToken } from "@angular/core";
import { CompilationConfig } from "../../../../loader-factory/src/models/config.model";

export const COMPILATION_CONFIG = new InjectionToken<CompilationConfig>("compilation.config");
